import { Row } from 'reactstrap';
import { numeralFormatterCurrency, percentFormatter } from 'ns_libs/formatter';
import { IPermanentDebtInfo, IPermanentDebtsAggregate } from 'views/ProFormaTable/types';
import MetricOutputCard from '../../../../MetricOutputCard/MetricOutputCard';

export interface IPermDebtSummaryProps {
    permanentDebtsAggregate?: IPermanentDebtsAggregate;
    seniorPermanentLoan: IPermanentDebtInfo;
    showCents: boolean;
}

const PermDebtSummary = ({
    permanentDebtsAggregate,
    seniorPermanentLoan,
    showCents,
}: IPermDebtSummaryProps) => (
    <Row className="mx-n1 pb-3 px-3">
        <p className="mt-3 mb-0 font-16">Debt summary</p>
        <hr className="mt-1 w-100" />
        <div className="d-flex w-100 ProFormaPermanentDebt__summary-cards">
            <div className="w-100 mr-2">
                <MetricOutputCard
                    cardClassName="p-3 d-flex flex-column justify-content-center"
                    label={<span className="font-12 text-muted">Total DSCR</span>}
                    value={(
                        <>
                            <span className="font-24 mb-0 text-dark d-block">
                                {`${numeralFormatterCurrency(permanentDebtsAggregate?.totalDscr || 0, '0,0.00')}x`}
                            </span>
                            <span className="font-12 text-muted d-block">
                                Senior only: {`${numeralFormatterCurrency(seniorPermanentLoan?.loanDscr || 0, '0,0.00')}x`}
                            </span>
                        </>
                    )}
                />
            </div>
            <div className="w-100 mr-2">
                <MetricOutputCard
                    cardClassName="p-3 d-flex flex-column justify-content-center"
                    label={<span className="font-12 text-muted">Total debt yield</span>}
                    value={(
                        <>
                            <span className="font-24 mb-0 text-dark d-block">
                                {percentFormatter((permanentDebtsAggregate?.totalDebtYield || 0) * 100)}
                            </span>
                            <span className="font-12 text-muted d-block">
                                Senior only: {percentFormatter((seniorPermanentLoan?.loanDebtYield || 0) * 100)}
                            </span>
                        </>
                    )}
                />
            </div>
            <div className="w-100 mr-2">
                <MetricOutputCard
                    cardClassName="p-3 d-flex flex-column justify-content-center"
                    label={<span className="font-12 text-muted">Total LTV</span>}
                    value={(
                        <>
                            <span className="font-24 mb-0 text-dark d-block">
                                {percentFormatter((permanentDebtsAggregate?.totalLtv || 0) * 100)}
                            </span>
                            <span className="font-12 text-muted d-block">
                                Senior only: {percentFormatter((seniorPermanentLoan?.loanLtv || 0) * 100)}
                            </span>
                        </>
                    )}
                />
            </div>
            <div className="w-100">
                <MetricOutputCard
                    cardClassName="p-3 d-flex flex-column justify-content-center"
                    label={<span className="font-12 text-muted">Net equity at refinance</span>}
                    value={(
                        <>
                            <span className="font-24 mb-0 text-dark d-block">
                                {numeralFormatterCurrency(
                                    permanentDebtsAggregate?.totalEquityDifference || 0,
                                    showCents ? '$0,0.00' : '$0,0',
                                )}
                            </span>
                            <span className="font-12 text-muted d-block">
                                Senior only: {numeralFormatterCurrency(
                                    seniorPermanentLoan.equityDifference || 0,
                                    showCents ? '$0,0.00' : '$0,0',
                                )}
                            </span>
                        </>
                    )}
                />
            </div>
        </div>
    </Row>
);

export default PermDebtSummary;
